import { Component } from '@angular/core';

@Component({
  selector: 'app-home10',
  templateUrl: './home10.component.html',
  styleUrls: ['./home10.component.scss']
})
export class Home10Component {}
